function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("body").classList.add("cart-drawer--visible");
  sellingPlan();
  selectorSelling();
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("cart-drawer--visible");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  console.log('entre a update cart')
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  removeCartItems();
  sellingPlan();
  selectorSelling();
}

function removeCartItems() {
  document
  .querySelectorAll(".cart__remove")
  .forEach((e) => {
    e.addEventListener("click", async () => {
      const rootItem =
          e.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement;
      const key = rootItem.getAttribute("data-line-item-key");

      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);

      // Update cart
      updateCartDrawer();

    });
  });
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();
removeCartItems();

document.querySelectorAll('.product-form__cart-submit').forEach((form) => {
    form.addEventListener("click", async (e) => {
      e.preventDefault();

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      console.log('esto es carrito', cart)  
      setTimeout(() => {
        updateCartItemCounts(cart.item_count);
      }, 200);


      // Update cart
      setTimeout(async () => {
        await updateCartDrawer();
        console.log('actualice carrito')

        // Open cart drawer
        openCartDrawer();
      }, 500);
    });
});

async function addToCartQuick() {
  console.log('entre al add to car quick of pop up')

  // Get cart count
  const res = await fetch("/cart.js");
  const cart = await res.json();
  console.log('esto es carrito', cart);  
  setTimeout(() => {
    updateCartItemCounts(cart.item_count);
  }, 200);

  // Update cart
  setTimeout(async () => {
    await updateCartDrawer();
    console.log('actualice carrito');

    // Open cart drawer
    openCartDrawer();
  }, 500);
}



document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

iconCart = document.querySelector('.shoppingcart_btn');
iconCart.addEventListener("click", (e) => {
   e.preventDefault();
    openCartDrawer();
});



// Selector SKIO PLAN//
function sellingPlan() {
  document.querySelectorAll('.upgrade-btn').forEach(button => {
      button.addEventListener('click', (e) => {
          e.preventDefault();
          const productId = button.getAttribute('data-cart-item-key');
          const sellingPlan = button.getAttribute('data-first-selected-selling-plan-id');
          const quantity = button.getAttribute('data-product-qty');

          updateChangeCart(productId, sellingPlan, quantity);
      });
  });
}

function selectorSelling() {
  document.querySelectorAll('.subscription-select').forEach(button => {
      button.addEventListener('change', (e) => {
          e.preventDefault();
          const productId = button.getAttribute('data-cart-item-key');
          const sellingPlan = document.querySelector('.subscription-select.js-purchase-select').value;
          const quantity = button.getAttribute('data-product-qty');

          updateChangeCart(productId, sellingPlan, quantity);
      });
  });
}

const updateChangeCart = async(product_id, selling_plan, qty) => {
  let formData = {
      'id': product_id,
      'selling_plan': selling_plan,
      'quantity': qty
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
      updateCartDrawer();
      console.log('Response:', response)
  })
  .catch((error) => {
      console.error('Error:', error);
  });

}